module.exports = __webpack_public_path__ + "img/lock.85dc00f3.svg";